import Resources from '../../../helpers/resources';
import {
    PARTICIPATION,
    LIVE_MATHS,
    SKILL_QUESTS_MASTERY
} from '../../report-filters/filter-constants';
import exportActivityMasteryReport from './export-activity-mastery-report';
import exportLiveMathsReport from './export-live-maths-report';
import exportParticipationReport from './export-participation-report';

import activeFiltersSelectors from '../../report-filters/redux/active-filters/active-filters-selectors';
import downloadAction from '../download-report/download-report-actions';
import { exportSkillQuestsMasteryReport } from './export-skill-quests-mastery-report';
import { trackEvent, ANALYTICS_EVENTS } from '../../../helpers/analytics';

export const REPORT_EXPORTED = 'REPORT_EXPORTED';

export const REPORT_LEVEL_ALL_YEARS = 'REPORT_LEVEL_ALL_YEARS';
export const REPORT_LEVEL_YEAR_GROUP_TEACHER =
    'REPORT_LEVEL_YEAR_GROUP_TEACHER';
export const REPORT_LEVEL_ALL_CLASSES = 'REPORT_LEVEL_ALL_CLASSES';
export const REPORT_LEVEL_SINGLE_CLASS = 'REPORT_LEVEL_SINGLE_CLASS';
export const REPORT_LEVEL_GROUP = 'REPORT_LEVEL_GROUP';
export const REPORT_LEVEL_STUDENT = 'REPORT_LEVEL_STUDENT';

export const REPORT_LEVELS = [
    REPORT_LEVEL_ALL_YEARS,
    REPORT_LEVEL_YEAR_GROUP_TEACHER,
    REPORT_LEVEL_ALL_CLASSES,
    REPORT_LEVEL_SINGLE_CLASS,
    REPORT_LEVEL_GROUP,
    REPORT_LEVEL_STUDENT
];

export const EXPORT_RESOURCE_METHODS = {
    [REPORT_LEVEL_ALL_YEARS]: 'allYearsExport',
    [REPORT_LEVEL_YEAR_GROUP_TEACHER]: 'yearGroupTeacherExport',
    [REPORT_LEVEL_ALL_CLASSES]: 'allClassesExport',
    [REPORT_LEVEL_SINGLE_CLASS]: 'singleClassExport',
    [REPORT_LEVEL_GROUP]: 'singleClassExport',
    [REPORT_LEVEL_STUDENT]: 'studentExport'
};

export const SKILL_QUESTS_EXPORT_RESOURCE_METHODS = {
    CLASSROOM: 'skillQuestsMasteryClassroomExport',
    CLASSROOM_CUSTOM_DATE: 'skillQuestsMasteryClassroomExportCustomDate',
    GROUP: 'skillQuestsMasteryGroupExport',
    GROUP_CUSTOM_DATE: 'skillQuestsMasteryGroupExportCustomDate',
    STUDENT: 'skillQuestsMasteryStudentExport',
    STUDENT_CUSTOM_DATE: 'skillQuestsMasteryStudentExportCustomDate'
};

export const FILE_FORMAT = {
    PDF: 'pdf',
    EXCEL: 'excel'
};

function exportReport(fileFormat) {
    return (dispatch, getState) => {
        const state = getState();
        const reportId = activeFiltersSelectors.selectReportId(state);
        const reportLevel = activeFiltersSelectors.selectReportLevel(state);
        const i18n = window.i18n;
        let exportParams;

        trackEvent(ANALYTICS_EVENTS.reportExported, {
            report: reportId,
            level: reportLevel,
            format: fileFormat
        });

        switch (reportId) {
            case PARTICIPATION:
                exportParticipationReport(
                    getState,
                    reportLevel,
                    dispatch,
                    i18n,
                    fileFormat
                );
                break;

            case LIVE_MATHS:
                exportParams = exportLiveMathsReport(getState, reportLevel);
                break;
            case SKILL_QUESTS_MASTERY:
                /*
                Skills quest mastery was created well after all previous report types. BE decided
                to not follow existing structure so we treat this case differently to the others.
                 */
                exportSkillQuestsMasteryReport(
                    reportLevel,
                    dispatch,
                    state,
                    i18n
                );
                break;
            default:
                exportParams = exportActivityMasteryReport(
                    getState,
                    reportLevel,
                    i18n
                );
                break;
        }

        if (exportParams) {
            const { data, resourcesMethod, params } = exportParams;
            const action = exportReportData(data, resourcesMethod, params);
            if (action) {
                dispatch(action);
            }
        }
    };
}

function exportReportData(data, resourcesMethod, params = null) {
    return Resources[resourcesMethod]
        .post(params)
        .withBody(data)
        .send()
        .then((payload) => {
            if (payload.valid) {
                const paramIdx = payload.verb.url.indexOf('?');
                if (paramIdx !== -1) {
                    payload.verb.url = payload.verb.url.substring(0, paramIdx);
                }
                return {
                    type: REPORT_EXPORTED,
                    payload: {
                        downloadUrl: `${payload.verb.url}/${payload.data}`
                    }
                };
            }
            return null;
        });
}

function downloadStudentReport() {
    return (dispatch, getState) => {
        const state = getState();
        trackEvent(ANALYTICS_EVENTS.reportDownloaded, {
            report: activeFiltersSelectors.selectReportId(state),
            level: activeFiltersSelectors.selectReportLevel(state)
        });
        const action = downloadAction();
        if (action) {
            dispatch(action);
        }
    };
}

export default { exportReport, downloadStudentReport };
export { exportReportData };



// WEBPACK FOOTER //
// ./components/sub-heading/export-report/export-report-actions.js